import { useState } from 'react';

// Material UI
import { Grid, Button, Container } from '@mui/material';
import { Add } from '@mui/icons-material';

import Swal from 'sweetalert2';

// Componentes
import AdminLayout from '@components/MainPage/AdminLayout';
import ActionHeader from '@components/Containers/ActionHeader';
import LoadingForm from '@components/LinearProgress/LoadingForm';
import TableBanners from '@components/ppm/TableBanners';
import FormBanners from '@components/ppm/FormBanners';

// SERVICES
import ppmServices from '@services/PpmServices';

// UTILS
import { convertBase64 } from '@utils/Utilities';

// MIDDLEWARE
import middleware from '@middlewares/middleware';

const Banner = ({ id }) => {
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [refreshApi, setRefreshApi] = useState(false);
    const hasAddPermission = middleware.checkMenuAction('Agregar');
    const titleModal = 'Agregar banner PPM';

    // Determina qué servicio usar según la ruta
    const currentPath = window.location.pathname;
    const isFocaRoute = currentPath.startsWith('/foca');
    const apiServiceId = isFocaRoute ? 1 : 0

    const handleInsertData = async (values) => {
        try {
            setLoading(true);
            const file = values.files[0]?.file;

            if (file) {
                let base64File;

                // Verifica si file ya está en base64
                if (typeof file === "string" && file.startsWith("data:image")) {
                    base64File = file;
                } else {
                    base64File = await convertBase64(file);
                }

                values.files[0].file = base64File;
            }

            const result = await ppmServices.setBanner({
                ...values,
                ...(apiServiceId ? { foca: true } : {})
            });

            const { results, message } = result;

            if (results) {
                setRefreshApi((prev) => !prev);
                Swal.fire({
                    title: message,
                    icon: 'success',
                    customClass: { container: 'modal-alert' },
                });
                setOpenModal(false);
            } else {
                throw new Error(message);
            }
        } catch (error) {
            Swal.fire({
                title: error.message,
                icon: 'warning',
                customClass: { container: 'modal-alert' },
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AdminLayout>
            <Container maxWidth={false} key={id}>
                <ActionHeader title={isFocaRoute ? 'Galería banners FOCA' : 'Galería banners PPM'} isCustom={true}>
                    <Button
                        variant="contained"
                        color="primaryDark"
                        size="small"
                        endIcon={<Add />}
                        onClick={() => setOpenModal(true)}
                    >
                        Agregar Nuevo
                    </Button>
                </ActionHeader>
                <LoadingForm
                    isLoading={loading}
                    isOpen={loading}
                    setIsOpen={() => setLoading(!loading)}
                    loadinMessage={'Cargando...'}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TableBanners apiServiceId={apiServiceId} setIsLoading={(e) => setLoading(e)} refresh={refreshApi} />
                    </Grid>
                </Grid>
                {openModal && (
                    <FormBanners
                        apiServiceId={apiServiceId}
                        setModalOpen={setOpenModal}
                        modalOpen={openModal}
                        title={titleModal}
                        setData={handleInsertData}
                    />
                )}
            </Container>
        </AdminLayout>
    );
};

export default Banner;
